// components/Hero.jsx
import React from "react";
import AllInclusiveIcon from "@mui/icons-material/AllInclusive";
import PsychologyIcon   from "@mui/icons-material/Psychology";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

import "./../landingPageStyle.css"
import FinalCTA from "./FinalCTA";

export default function Hero() {
  return (
    <section className="
      relative min-h-auto flex flex-col items-center justify-center
      text-center pt-[90px] px-[6%] overflow-hidden mt-16
    ">
      {/* Floating orbs */}
      <div className="
        absolute w-[600px] h-[600px] rounded-full pointer-events-none
        -top-24 -left-36 animate-orb-1
        bg-[radial-gradient(circle,rgba(27,58,107,0.12)_0%,transparent_70%)]
        blur-[80px]
      " />
      <div className="
        absolute w-[400px] h-[400px] rounded-full pointer-events-none
        -bottom-12 -right-24 animate-orb-2
        bg-[radial-gradient(circle,rgba(233,30,140,0.08)_0%,transparent_70%)]
        blur-[80px]
      " />
      <div className="
        absolute w-[300px] h-[300px] rounded-full pointer-events-none
        top-[40%] left-[60%] animate-orb-3
        bg-[radial-gradient(circle,rgba(15,212,160,0.06)_0%,transparent_70%)]
        blur-[80px]
      " />

      {/* Grid overlay */}
      <div className="
        absolute inset-0 animate-grid-pulse
        [background-image:linear-gradient(rgba(27,58,107,0.06)_1px,transparent_1px),linear-gradient(90deg,rgba(27,58,107,0.06)_1px,transparent_1px)]
        [background-size:64px_64px]
        [mask-image:radial-gradient(ellipse_90%_90%_at_50%_50%,black_0%,transparent_100%)]
      " />

      <div className="relative z-[2]">
        {/* Badge */}
        <div className="
          inline-flex items-center gap-2 mb-8
          bg-pink-200 border border-pink-600
          rounded-full px-4 py-3
          text-13 font-medium font-dm pink-text
        ">
          {/* <span className="w-1.5 h-1.5 bg-pink rounded-full animate-blink" /> */}
          <div className="badge-dot blink"></div>
          <strong>1 Million Tracks · Ready to Match</strong>
        </div>

        {/* Headline */}
        <div className="
          header-h1
          mb-16
        ">
          {[
            "World-class music",
            <span key="global">for <span className="text-transparant">global</span></span>,
            <span key="story" className="pink-text">storytellers</span>,
          ].map((line, i) => (
            <span
              key={i}
              className="block line-reveal overflow-hidden px-1"
              style={{ animationDelay: `${0.1 + i * 0.15}s` }}
            >
              {line}
            </span>
          ))}
        </div>

        {/* Stats row */}
        <div className="
          flex border border-[rgba(27,58,107,0.18)] rounded-2xl
          relative z-2 items-center
          stats-row mx-1
        ">
          {[
            { num: <div className="navy-text" sx={{ fontSize: 40}}>1<span className="pink-text">M+</span></div>, label: "Pre-Cleared Tracks" },
            {
              num: <AllInclusiveIcon sx={{ fontSize: 40, color: "#E91E8C" }} />,
              label: "Perpetual Licence",
            },
            {
              num: <PsychologyIcon sx={{ fontSize: 40, color: "#0a9e78" }} />,
              label: "Search in MOTHER TONGUE",
            },
          ].map(({ num, label }, i, arr) => (
            <div
              key={i}
              className={`
                flex-1 text-center
                ${i < arr.length - 1 ? "border-r border-[rgba(27,58,107,0.1)] dark:border-[rgba(255,255,255,0.08)]" : ""}
                relative overflow-hidden group
                stat-item
                after:content-[''] after:absolute after:bottom-0 after:left-0 after:right-0
                after:h-0.5 after:bg-pink after:scale-x-0 after:origin-left
                after:transition-transform after:duration-[350ms]
                hover:bg-[rgba(233,30,140,0.03)] hover:after:scale-x-100
              `}
            >
              <div className="stat-icon font-extrabold leading-none mb-3 flex items-center justify-center">
                {num}
              </div>
              <div className="stat-label">
                {label}
              </div>
            </div>
          ))}
        </div>

        <p className="sub-header py-8 px-1">
          <strong>Music by Pros. Matching by Maya (AI).</strong>
        </p>

        {/* CTAs */}
        {/* <div className="
          flex items-center gap-4 justify-center flex-wrap mb-1
          [animation:fadeUp_0.8s_0.75s_cubic-bezier(.4,0,.2,1)_both]
        ">
          <span className="flex-wrap jusitify-center">
            <a href="/register/free" 
              className="pink-btn">
              Start Free
              <ArrowForwardIcon sx={{ fontSize: 20 }} className="transition-transform duration-200 group-hover:translate-x-1 mx-1" />
            </a>
            <p className="mt-4 feature-desc relative">
              Unlock AI search and all features. No card.
            </p>
          </span>
          <span className="pr-4 flex justify-center lic-step-title" style={{marginTop: "-38px"}}>or</span>
          <span className="flex-wrap justify-center">
            <a href="/" 
              className="ghost-btn">
              Explore The Catalogue
            </a>
            <p className="mt-4 feature-desc relative">
              No sign up. Browse and keyword search only.
            </p>
          </span>
        </div> */}
      </div>
    </section>
  );
}
